<template>
    <div class="textWrapper message-wrapper">
    <p :style="[$kmsTheme ? $kmsTheme.styles.messageText : null, {fontSize : fontSize + 'px'}, {color : messageColour}]" :id="message.noticeMessageId" class="resize">
        <template v-if="message.messageTitle"><span :style="[{color:message.messageTitleColour}, message.messageTitleFont ? {'font-family':message.messageTitleFont} : null]">
            {{message.messageTitle}}</span><br /></template>
        <span :style="[message.messageFont ? {'font-family':message.messageFont} : null]">
            {{message.message}}
        </span>
    </p>
    </div>        
</template>

<script>
    import Vue from 'vue';
    import messageMixin from './../../mixins/text-message';

    export default {
        mixins:[messageMixin],
        created() {
            this.parentClass = ".textWrapper"
        }
    }



</script>
<style>
    .textWrapper {
        width: 100%;
        height: 100%;
        margin-bottom: 0px;
        clear: both;
    }

    
</style>
